import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorFn } from '@angular/forms';
import { markAllAsTouched } from '../../../../../utils/markAllAsTouched';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { skillLevels } from '../../../../../utils/skillLevels';

@Component({
  selector: 'app-edit-technical-skills-modal',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, MatSelectModule, MatOptionModule, TranslateModule],
  templateUrl: './edit-technical-skills-modal.component.html',
  styleUrl: '../edit-modal.scss'
})
export class EditTechnicalSkillsModalComponent {

  technicalSkillsForm: FormGroup;
  loading: boolean = false;

  // Native selects: treat an empty placeholder ('') and a missing value (null) as the same value
  sameValue = (a: any, b: any) => (a ?? '') === (b ?? '');
  skillLevels = skillLevels;

  // Custom validator to check if the date is valid
  dateValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
    const dateValue = control.value;
    const year = new Date(dateValue).getFullYear();
    return isNaN(year) || year.toString().length !== 4 ? { invalidDate: true } : null;
  };

  constructor(
    public dialogRef: MatDialogRef<EditTechnicalSkillsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder 
  ) {
    
    this.technicalSkillsForm = this.fb.group({
      technicalSkill: [this.data.skill.technicalSkill || '', Validators.required],
      technicalSkillLevel: [this.data.skill.technicalSkillLevel || '', Validators.required]
    });

  }

  close(): void {
    this.dialogRef.close();
  }

  saveEditTechnicalSkills() {
    if (this.technicalSkillsForm.valid) {
      const editedTechnicalSkills = {
          technicalSkill: this.technicalSkillsForm.get('technicalSkill')?.value,
          technicalSkillLevel: this.technicalSkillsForm.get('technicalSkillLevel')?.value
      };
      this.dialogRef.close(editedTechnicalSkills);
    } else {
      markAllAsTouched(this.technicalSkillsForm); // Mark all fields as touched to show validation errors
    }
  }
}
